import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface NavItemProps {
  icon: React.ReactNode;
  label: string;
  to?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

const NavItem: React.FC<NavItemProps> = ({
  icon,
  label,
  to,
  onClick,
  disabled = false,
  className,
}) => {
  const baseClasses = cn(
    'flex items-center gap-3 px-3 py-2 rounded-md transition-colors w-full text-left',
    disabled
      ? 'text-muted-foreground cursor-not-allowed opacity-50'
      : 'text-foreground hover:bg-accent hover:text-accent-foreground cursor-pointer',
    className
  );

  const content = (
    <>
      <span className="flex-shrink-0">{icon}</span>
      <span className="truncate">{label}</span>
    </>
  );

  if (to && !disabled) {
    return (
      <NavLink
        to={to}
        className={({ isActive }) =>
          cn(baseClasses, isActive && 'bg-accent text-accent-foreground')
        }
      >
        {content}
      </NavLink>
    );
  }

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={baseClasses}
    >
      {content}
    </button>
  );
};

export default NavItem;
